// generated from 73_045 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const subscriptionGroupFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("subscription_group_filter"),
  comparison_key: z.enum([
    "1", // 63_360 (86.74%)
    "2", // 9_685 (13.26%)
  ]),
  display_name: z.string(),
  // undefined: 21_126 (28.92%), defined 51_919 (71.08%)
  raw_value: common.objectId.optional(),
  value: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
